// extracted by mini-css-extract-plugin
export default {"agreement":"styles_agreement__h4fuy","success":"styles_success__oCe0G","failure":"styles_failure__pazc5"};